const getEnvByName = (name: string): string | undefined => {
  return (window as any)?.ilrdConfigs?.[name] || import.meta.env[name];
};

export { getEnvByName };
